import React, { forwardRef } from 'react';
import { ActionIcon, Button } from '@mantine/core';
import './MapControlButton.css';

// Floating controls keep a 44px target on desktop as well as touch screens.
const MapControlButton = forwardRef(function MapControlButton({ label, showLabel = false,
  active = false, children, className = '', style, ...props }, ref) {
  const shared = {
    ref, type: 'button', variant: 'default', radius: 'sm',
    'aria-label': label, title: label, 'data-active': active || undefined,
    className: `cos-map-control ${className}`, style, ...props,
  };
  return showLabel
    ? <Button {...shared} h={44} leftSection={children}>{label}</Button>
    : <ActionIcon {...shared} size={44}>{children}</ActionIcon>;
});

export default MapControlButton;
